import { agreementIsSingleLanguage, agreementTextVersion, type AgreementLanguage, type V2Agreement } from '../../domain/agreement';
import { useT, type MessageKey } from '../../i18n/i18n';
import { SegmentedControl } from '../../ui/components';

// v5 (Owner 2026-10-28: 「按照客户的语言选择单独出，不用双语。可以要求中文就是中文，老外客户直接出英文」): the two
// languages the agreement is printed in, each named in its own language (the App Language picker's labels).
const OPTIONS: ReadonlyArray<{ key: AgreementLanguage; label: MessageKey }> = [
  { key: 'en-US', label: 'language.english' },
  { key: 'zh-CN', label: 'language.chinese' }
];

// The language row of the agreement card and of the signing sheet. A document signed under an older copy is
// bilingual: nothing is selected and the note says so (choosing a language re-opens it under the current copy).
export function AgreementLanguageRow(props: { agreement: V2Agreement; onChange: (language: AgreementLanguage) => void; disabled?: boolean; testId: string }) {
  const { t } = useT();
  const bilingual = !agreementIsSingleLanguage(agreementTextVersion(props.agreement));
  return (
    <div className="agreement-language" data-testid={props.testId} data-language={bilingual ? 'bilingual' : props.agreement.documentLanguage}>
      <div className="form-rows">
        <div className="form-row agreement-language-row">
          <span className="form-row-label">{t('agreement.languageLabel')}</span>
          <SegmentedControl
            variant="compact"
            ariaLabel={t('agreement.languageLabel')}
            value={bilingual ? null : props.agreement.documentLanguage}
            onChange={props.onChange}
            options={OPTIONS.map((option) => ({ key: option.key, label: t(option.label), disabled: props.disabled, testId: `${props.testId}-${option.key}` }))}
          />
        </div>
      </div>
      <p className="card-note">{bilingual ? t('agreement.languageBilingualOld') : t('agreement.languageNote')}</p>
    </div>
  );
}
